import React from 'react'
import { reportClientError } from 'utils/report-error'

class ErrorBoundary extends React.Component {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, info) {
    reportClientError(error, { componentStack: info?.componentStack })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className='h-screen w-full flex flex-col items-center justify-center gap-4 px-6 text-center'>
          <div className='text-lg font-semibold text-gray-800'>
            Something went wrong.
          </div>
          <button
            onClick={() => window.location.reload()}
            className='px-5 py-2.5 rounded-lg bg-blue-600 text-white text-sm font-medium'
          >
            Reload
          </button>
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
